import {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import {
  Card,
  Grid,
  TextField,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { LoadingButton } from '@mui/lab';
import { t } from "i18next";
import api from "../../helpers/api/Api";
import AppConfig from "../../helpers/constants/AppConfig";
import ApiUrls from "../../helpers/urls/ApiUrls";
import { showStatus } from "../../helpers/api/errors/ShowStatus";
import { appendFormData } from "../../helpers/functions/form-append";
import MDBox from "components/MDs/MDBox";
import MDTypography from "components/MDs/MDTypography";
import DashboardLayout from "../../components/LayoutContainers/DashboardLayout";

function DefaultParams() {
  const refreshRate = useSelector(state => state.refresh_rate);
  const [values, setValues] = useState({
    param: '',
    value: ''
  });
  const { param, value } = values;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (value, name) => {
    setValues({
      ...values,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: null,
    });
  };

  useEffect(() => {
    if (param !== '') {
      handleChange(refreshRate, "value");
    }
  }, [param]);

  const checkInputs = () => {
    let temp_errors = {};

    if (values.param === "") {
      temp_errors.param = t("message.required", { item: t("default_param.parameter") });
    }
    if (values.value === "") {
      temp_errors.value = t("message.required", { item: t("default_param.default_value") });
    }

    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      setParam();
    }
  }

  const setParam = () => {
    setLoading(true);
    let postFormData = appendFormData(values);

    api.post(ApiUrls.params.set, postFormData)
      .then((response) => {
        setLoading(false);
        showStatus(response.data.status === "success" ? "success_param" : "error_param");
      })
      .catch((error) => {
        setLoading(false);
        showStatus("error_param");
      });
  }

  return (
    <DashboardLayout>
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              mb={3}
              py={3}
              px={2}
              variant="gradient"
              bgColor={AppConfig.color}
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                {t("default_param.title")}
              </MDTypography>
            </MDBox>

            <Card>
              <MDBox py={3} px={5}>
                <Grid container spacing={2} justifyContent="center" sx={{ mt: 1, mb: 2 }} className="flex-column-md">
                  <Grid item md={6}>
                    <FormControl fullWidth>
                      <InputLabel id="permission">{t("default_param.parameter")}</InputLabel>
                      <Select
                        labelId="param"
                        id="param-select"
                        value={values.param}
                        error={errors?.param}
                        label={t("default_param.parameter")}
                        onChange={(e) => handleChange(e.target.value, "param")}
                      >
                        <MenuItem value="refreshrate">زمان به روز رسانی</MenuItem>
                      </Select>
                      {errors?.param && <FormHelperText error>{errors?.param}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item md={6}>
                    <TextField id="value" label={`${t("default_param.default_value")}${values.param ? " (ثانیه)" : ""}`} variant="outlined" fullWidth
                               value={values.value} error={errors?.value} helperText={errors?.value}
                               onChange={(e) => handleChange(e.target.value, "value")} />
                  </Grid>

                  <Grid item md={4} mt={3}>
                    <LoadingButton
                      color={AppConfig.color}
                      loading={loading}
                      startIcon={<Add />}
                      variant="outlined"
                      fullWidth
                      onClick={checkInputs}
                    >
                      تنظیم مقدار پارامتر
                    </LoadingButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default DefaultParams;
